import React from 'react';
import { Link } from 'react-router-dom';

const CommonCtaArea = ({
   title = <>Ready to take your <br /> business to the next level?</>,
   subtitle = "Contact us today to discuss your needs !",
   buttonText = "Work with us",
   buttonLink = "/contact",
}) => {
   return (
      <>
         <section className="cta__area pt-100 pb-100" style={{
            background: `url(assets/img/cta/cta-bg.jpg)`
            , backgroundPosition: 'center', backgroundSize: 'cover'
         }} >
            <div className="tw-container tw-mx-auto p-relative">
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  <div className="tw-w-full tw-px-3 xl:tw-w-10/12 xl:tw-ml-[8.3333%]">
                     <div className="cta__content tw-text-center">
                        <h2>{title}</h2>
                        <p>{subtitle}</p>
                        <div className="cta__btn mt-5">
                           <Link to={buttonLink} className="z-btn z-btn-transparent mb-30">{buttonText}</Link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default CommonCtaArea;